
import Block from 'Mixins/Block';
import Swiper from 'Libs/swiper/swiper.min';

export default Block('component-slider', {
	onLoad (block) {

		block.forEach((node, index) => {

			const className = `component-slider-index-${index}`;

			node.classList.add(className);

			const swiperContainer 	= `.${className} .swiper-container`;
			const pagination 		= `.${className} .swiper-pagination`;
			const next 				= `.${className} .swiper-button-next`;
			const prev 				= `.${className} .swiper-button-prev`;
			const slides 			= node.querySelectorAll('.swiper-slide');
			const controller 		= node.querySelector('.component-slider__controller-wrapper');

			if (slides && slides.length > 1) {

				new Swiper(swiperContainer, {
					loop: true,
					pagination: {
						el: pagination,
						type: 'fraction',
					},
					navigation: {
						nextEl: next,
						prevEl: prev,
					},
				});

				if (controller) {

					controller.classList.add('component-slider__controller-wrapper--initialized');

				}

			}

		});
	}
});